import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import FieldLabel from '../../shared/FieldLabel';
import Select from '../../shared/Select'

export const LayoutManagementSelect = ({ value = null, options, onSelect }) => {
  return (
    <Row>
      <Col className='mb-3'>
        <FieldLabel label='Layout' isnLabel={false} />
        <Select
          value={value}
          options={options}
          onChange={onSelect}
        />
      </Col>
    </Row>
  );
};

LayoutManagementSelect.propTypes = {
  value: PropTypes.string,
  options: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
};


// WEBPACK FOOTER //
// src/components/LayoutManagement/LayoutManagementSelect/index.jsx